module.exports = __webpack_public_path__ + "img/pin-black-diamond.1612e661.png";